import api from 'api';

export const loadStatuses = api('GET /api/partner-companies/filters/statuses');

export const loadOwners = api('GET /api/partner-companies/filters/owners');

export const loadCreators = api('GET /api/partner-companies/filters/creators');

export const loadCountries = api(
  'GET /api/partner-companies/filters/countries'
);
